import React from 'react';
import { App as AntApp, ConfigProvider } from 'antd';

type TProps = {
  children?: React.ReactNode;
};

export const App: React.FunctionComponent<TProps> = ({ children }) => {
  return (
    <AntApp>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: '#005485',
            borderRadius: 2,
          },
          components: {
            Button: {
              defaultColor: '#005485',
            },
            Tabs: {
              titleFontSize: 16,
            }
          },
        }}
      >
        <div className="App">{children}</div>
      </ConfigProvider>
    </AntApp>
  );
};
